@if (singleDownloadSize() === undefined && !iosDownloadMode()) {
  <app-context-menu
    [options]="{ width: '240px', noSpacing: true }"
    #menu
    contextHoverIdentifier="asset-{{ asset().id }}"
  >
    <div contextButton [appTooltip]="'Download'">
      <ng-container *ngTemplateOutlet="template"></ng-container>
    </div>
    <div contextContent>
      @if (menu.isOpen()) {
        <app-download-size-selection
          [galleryPermissions]="galleryPermissions()"
          [asset]="asset()"
          [gallery]="gallery()"
          (onSelect)="download($event); menu.close()"
        >
        </app-download-size-selection>
      }
    </div>
  </app-context-menu>
} @else {
  @if (!downloading() || !downloadTemplate()) {
    <div (click)="download(singleDownloadSize())">
      <ng-container *ngTemplateOutlet="template"></ng-container>
    </div>
  } @else {
    <ng-content select="[downloadingContent]"></ng-content>
  }
}
<ng-template #template>
  <ng-content></ng-content>
</ng-template>
